import React, { useState } from "react";
import { CONTACT_TOPICS, WA_NUMBER } from "../constants";

export default function KontakCustomForm() {
  const [userName, setUserName] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [selectedTopic, setSelectedTopic] = useState(CONTACT_TOPICS[0].title);
  const [customNote, setCustomNote] = useState("");

  const handleSendCustomMessage = (e: React.FormEvent) => {
    e.preventDefault();
    let text = `Halo Galura, saya ${userName || "Pengunjung Website"}`;
    if (userCompany) {
      text += ` dari ${userCompany}`;
    }
    text += `.\n\nTopik Kebutuhan: ${selectedTopic}`;
    if (customNote) {
      text += `\n\nPesan/Pertanyaan: ${customNote}`;
    } else {
      text += `\n\nSaya ingin berkonsultasi mengenai layanan ini.`;
    }

    const encodedText = encodeURIComponent(text);
    window.open(
      `https://wa.me/${WA_NUMBER}?text=${encodedText}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="lg:col-span-7 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 dark:border-slate-800 dark:bg-slate-900 shadow-xl">
      <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider text-emerald-700 bg-emerald-100 dark:bg-emerald-950/60 dark:text-emerald-400 border border-emerald-300/40 mb-3">
        ✏️ Form Pesan Kustom WhatsApp
      </span>
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
        Kirim Pesan WhatsApp Langsung
      </h3>
      <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-400 mb-6">
        Isi form berikut dan tombol akan otomatis mengarahkan ke obrolan
        WhatsApp dengan pesan terformat rapi.
      </p>

      <form onSubmit={handleSendCustomMessage} className="space-y-4">
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 mb-1.5">
            Nama Anda *
          </label>
          <input
            type="text"
            required
            placeholder="Contoh: Budi Santoso"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-950 px-4 py-3 text-sm text-slate-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
          />
        </div>

        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 mb-1.5">
            Nama Perusahaan / Organisasi (Opsional)
          </label>
          <input
            type="text"
            placeholder="Contoh: PT Sukses Mandiri"
            value={userCompany}
            onChange={(e) => setUserCompany(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-950 px-4 py-3 text-sm text-slate-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
          />
        </div>

        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 mb-1.5">
            Kategori Topik Kebutuhan
          </label>
          <select
            value={selectedTopic}
            onChange={(e) => setSelectedTopic(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-950 px-4 py-3 text-sm text-slate-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
          >
            {CONTACT_TOPICS.map((t) => (
              <option key={t.title} value={t.title}>
                {t.badge} – {t.title}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-slate-700 dark:text-slate-300 mb-1.5">
            Pesan / Detail Pertanyaan
          </label>
          <textarea
            rows={4}
            placeholder="Tuliskan detail kebutuhan software, lokasi event, atau pertanyaan Anda..."
            value={customNote}
            onChange={(e) => setCustomNote(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-950 px-4 py-3 text-sm text-slate-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
          />
        </div>

        <button
          type="submit"
          className="w-full inline-flex items-center justify-center gap-2.5 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/40 hover:scale-[1.01] transition-all duration-300"
        >
          <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-1.157 4.228 4.24-1.111z" />
          </svg>
          <span>Buka WhatsApp Sekarang</span>
        </button>
      </form>
    </div>
  );
}
